export default "__VITE_ASSET__B6csmwG8__"